import { DurationType, getSessionDuration } from '@efacity/common';

export const displaySessionDuration = (session) => {
  if (session.durationType === DurationType.selfPaced) return 'Self-paced';
  if (session?.schedule?.instances) return getSessionDuration(session.schedule.instances.length, session.type);
  return '-';
};
